import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { TogglePanelCallback } from 'angular/custom/components/toggle-panel.component';

class BalancingGroupPortfolioCodeEnableComponentCtrl implements ng.IController {
    private enabledSettings: PossibleSettings[];
    public settings: TsoGeneralSettingsDto;
    public portfolioCodeOrBalancingGroupEnabled: boolean;
    //variable is needed to reset the setting in case of error
    public balancingGroupPortfolioCodeSelectionForReset: BalancingGroupPortfolioCodeSelection;
    //variable is needed to not switch balancing group/ portfolio code immediately in the UI but just if the confirmation dialog is confirmed
    public cachedBalancingGroupPortfolioCodeSelection: BalancingGroupPortfolioCodeSelection;
    public tsoRefId: number;
    public disableSettingSelection: boolean;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private errorHandler: ErrorHandler,
        private growl: Growl
    ) {}

    $onInit() {
        if (
            this.settings.balancingGroupPortfolioCodeSelection !==
            'NOT_APPLICABLE'
        ) {
            this.portfolioCodeOrBalancingGroupEnabled = true;
        } else {
            this.portfolioCodeOrBalancingGroupEnabled = false;
        }
        this.disableSettingSelection = false;
        this.balancingGroupPortfolioCodeSelectionForReset = angular.copy(
            this.settings.balancingGroupPortfolioCodeSelection
        );
    }

    public toggleBalancingGroupPortfolioCode() {
        this.cachedBalancingGroupPortfolioCodeSelection =
            this.settings.balancingGroupPortfolioCodeSelection;
        this.settings.balancingGroupPortfolioCodeSelection =
            this.balancingGroupPortfolioCodeSelectionForReset;
    }

    public saveBalancingGroupPortfolioCodeSelection() {
        this.disableSettingSelection = true;
        this.settings.balancingGroupPortfolioCodeSelection =
            this.cachedBalancingGroupPortfolioCodeSelection;
        this.TransmissionSystemOperator.saveBalancingGroupPortfolioCodeSelection(
            { id: this.tsoRefId },
            { value: this.settings.balancingGroupPortfolioCodeSelection },
            (res) => {
                if (
                    this.settings.balancingGroupPortfolioCodeSelection ===
                    'BALANCING_GROUP'
                ) {
                    this.resetPortfolioCodeSettings();
                } else {
                    this.resetBalancingGroupSettings();
                }
                this.disableSettingSelection = false;
                this.balancingGroupPortfolioCodeSelectionForReset =
                    this.settings.balancingGroupPortfolioCodeSelection;
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            (err) => {
                this.settings.balancingGroupPortfolioCodeSelection =
                    this.balancingGroupPortfolioCodeSelectionForReset;
                this.disableSettingSelection = false;
                this.errorHandler(err);
            }
        );
    }

    public cancelBalancingGroupPortfolioCodeSwitch() {
        this.settings.balancingGroupPortfolioCodeSelection =
            this.balancingGroupPortfolioCodeSelectionForReset;
        this.cachedBalancingGroupPortfolioCodeSelection =
            this.balancingGroupPortfolioCodeSelectionForReset;
    }

    public setPortfolioCodeOrBalancingGroupEnabled(cb: TogglePanelCallback) {
        this.disableSettingSelection = true;
        this.TransmissionSystemOperator.saveBalancingGroupPortfolioCodeSelection(
            { id: this.tsoRefId },
            { value: 'NOT_APPLICABLE' },
            () => {
                this.settings.balancingGroupPortfolioCodeSelection =
                    'NOT_APPLICABLE';
                this.cachedBalancingGroupPortfolioCodeSelection =
                    this.settings.balancingGroupPortfolioCodeSelection;
                this.balancingGroupPortfolioCodeSelectionForReset =
                    this.settings.balancingGroupPortfolioCodeSelection;
                this.resetBalancingGroupSettings();
                this.resetPortfolioCodeSettings();
                this.disableSettingSelection = false;
                cb(true);
            },
            () => {
                this.disableSettingSelection = false;
                cb(false);
            }
        );
    }

    public saveValidatePortfolioCodeForDirection() {
        this.disableSettingSelection = true;
        this.TransmissionSystemOperator.saveValidatePortfolioCodeForDirection(
            { id: this.tsoRefId },
            this.settings.validatePortfolioCodeForDirection,
            (res) => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
                this.disableSettingSelection = false;
            },
            (err) => {
                this.disableSettingSelection = false;
                this.settings.validatePortfolioCodeForDirection =
                    !this.settings.validatePortfolioCodeForDirection;
                this.errorHandler(err);
            }
        );
    }

    private resetBalancingGroupSettings() {
        this.settings.balancingGroupSelectionBiddingST = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionBiddingLT = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionSecondaryST = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionSecondaryLT = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionSurrenderST = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionSurrenderLT = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionForUpgradeLT = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionForUpgradeST = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionFcfsST = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionFcfsLT = 'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionForFlowCommitmentForReverseAuction =
            'NOT_APPLICABLE';
        this.settings.balancingGroupSelectionForBuyBackForReverseAuction =
            'NOT_APPLICABLE';
        this.settings.requireBalancingGroupForTransferOfUseTrades = false;
    }

    private resetPortfolioCodeSettings() {
        this.settings.portfolioCodeSelectionBiddingST = 'NOT_APPLICABLE';
        this.settings.portfolioCodeSelectionBiddingLT = 'NOT_APPLICABLE';
        this.settings.portfolioCodeSelectionSecondaryST = 'NOT_APPLICABLE';
        this.settings.portfolioCodeSelectionSecondaryLT = 'NOT_APPLICABLE';
        this.settings.portfolioCodeSelectionSurrenderST = 'NOT_APPLICABLE';
        this.settings.portfolioCodeSelectionSurrenderLT = 'NOT_APPLICABLE';
        this.settings.portfolioCodeSelectionFcfsST = 'NOT_APPLICABLE';
        this.settings.portfolioCodeSelectionFcfsLT = 'NOT_APPLICABLE';
        this.settings.portfolioCodeSelectionForFlowCommitmentForReverseAuction =
            'NOT_APPLICABLE';
        this.settings.portfolioCodeSelectionForBuyBackForReverseAuction =
            'NOT_APPLICABLE';
        this.settings.validatePortfolioCodeForDirection = false;
    }
}

angular.module('app').component('pkpBalancingGroupPortfolioCodeEnable', {
    controller: BalancingGroupPortfolioCodeEnableComponentCtrl,
    template:
        require('app/operator-settings-general/balancing-group-portfolio-code-enable.component.html'),
    bindings: {
        settings: '=',
        tsoRefId: '=',
        enabledSettings: '<'
    }
});
